import { Component } from '@angular/core';
import { LanguageService } from '../language.service';

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
})
export class LanguageSwitcherComponent {
  languages = [
    { code: 'en', label: 'English', flag: 'assets/flags/en.jpg' },
    { code: 'fr', label: 'Français', flag: 'assets/flags/fr.jpg' },
    { code: 'it', label: 'Italiano', flag: 'assets/flags/it.jpg' },
    { code: 'de', label: 'Deutsch', flag: 'assets/flags/de.jpg' },
  ];

  currentLang = this.languageService.getLanguage();
  currentFlag = this.getFlag(this.currentLang);

  constructor(private languageService: LanguageService) {
    this.languageService.selectedLang$.subscribe((lang) => {
      this.currentLang = lang;
      this.currentFlag = this.getFlag(lang);
    });
  }

  changeLanguage(lang: string) {
    this.languageService.setLanguage(lang);
  }

  private getFlag(lang: string) {
    return (
      this.languages.find((l) => l.code === lang)?.flag || 'assets/flags/en.jpg'
    );
  }
}
